import TooltipMenu from 'components/pure/tooltips/TooltipMenu';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import DropDownMenuButton from 'components/pure/utils/DropDownMenuButton';
import React from 'react';
import AddToReviewDialog from 'components/pure/sharing/coaching/AddToReviewDialog';
import withCoachingPlanWizard from 'components/coaching/wizard/withCoachingPlanWizard';
import withAdHocPlanDialog from 'components/coaching/withAdHocPlanDialog';
import CoachingPlaylistActions from 'actions/coaching/CoachingPlaylistActions';

class CoachQuickActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showShareToCoachingPlan: false,
      flash: false,
    };
  }

  componentDidMount() {
    this.props.flashOnOpen &&
      setTimeout(() => {
        this.setState({flash: true}, () => {
          setTimeout(() => {
            this.setState({flash: false});
            CoachingPlaylistActions.flashedOnOpen();
          }, 1000);
        });
      }, 1000);
  }

  render() {
    const {showShareToCoachingPlan} = this.state;
    const {
      rep,
      fileUploadId,
      fileUpload,
      onShowMenu,
      onCoachNow,
      onFlashActions,
      authUser,
      button,
    } = this.props;

    const {flash} = this.state;

    return (
      <div>
        <div className="coaching-quick-actions">
          <TooltipMenu
            menu={
              <Menu>
                <MenuItem
                  primaryText="Add To Coaching Plan"
                  onClick={() => this.setState({showShareToCoachingPlan: true})}
                />
                <MenuItem
                  primaryText="Create Coaching Plan"
                  onClick={() =>
                    this.props.onCreatePlan({
                      coach: authUser,
                      rep,
                    })
                  }
                />
                <MenuItem
                  primaryText="Coach Now"
                  onClick={() =>
                    onCoachNow({
                      rep,
                      callId: fileUploadId,
                    })
                  }
                />
                {onFlashActions && (
                  <MenuItem primaryText="Leave Feedback" onClick={onFlashActions} />
                )}
              </Menu>
            }
            onShowMenu={onShowMenu}>
            {!rep.hidden &&
              (button ?? (
                <DropDownMenuButton
                  variant="outlined"
                  size="small"
                  fullWidth
                  className="ev-button"
                  flash={flash}>
                  Coach This Call
                </DropDownMenuButton>
              ))}
          </TooltipMenu>
        </div>
        <AddToReviewDialog
          open={showShareToCoachingPlan}
          fileUpload={fileUpload}
          callerTeamId={rep.teamId}
          authUser={authUser}
          onSubmit={() => this.setState({showShareToCoachingPlan: false})}
          onClose={() => this.setState({showShareToCoachingPlan: false})}
          onCoachNow={() => {
            this.setState({
              showShareToCoachingPlan: false,
            });
            onCoachNow({
              rep,
              callId: fileUploadId,
            });
          }}
          onCreatePlan={() =>
            this.setState({showShareToCoachingPlan: false}, () => {
              this.props.onCreatePlan({
                coach: authUser,
                rep,
              });
            })
          }
        />
      </div>
    );
  }
}

export default withCoachingPlanWizard(withAdHocPlanDialog(CoachQuickActions));
